export default __webpack_public_path__ + "static/clouds-far-bcbfe654728f4be75e2f15102fea322f.svg";